import React from "react";
import { Flex, Link, Text } from "@chakra-ui/react";

export default function PrivacyPolicy(): JSX.Element {
	return (
		<Flex justifyContent={"center"} alignItems={"center"} fontSize={"sm"}>
			<Link href="https://qoria.com/privacy" target="_blank" rel="noreferrer">
				View Privacy Policy
			</Link>
			<Text mx={4} color={"gray"}>
				|
			</Text>
			<Link href="https://qoria.com" target="_blank" rel="noreferrer">
				Powered by Qoria
			</Link>
		</Flex>
	);
}
